<div style="width: 400px; height: 500px;" data-cy="task-user-selection-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="task-user-selection-header-section">
      <div class="section-header-title" data-cy="task-user-selection-title-text">
        Select User
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; display: flex; flex-direction: column; overflow: hidden;" data-cy="task-user-selection-content-section">
      <div *ngIf="data.model.ForUserGroupID" style="flex-basis: fit-content;" data-cy="task-user-selection-filter-section">
        <mat-radio-group [(ngModel)]="isOnlyShowUsersInSelectedGroup" data-cy="task-user-selection-filter-radio">
          <mat-radio-button (change)="onAllGroupChange()" [value]="false" data-cy="task-user-selection-all-users-radio">All Users</mat-radio-button>
          <mat-radio-button (change)="onUserGroupChange(selectedUserGroup)" style="margin-left: 12px;" [value]="true" data-cy="task-user-selection-group-users-radio">Users in {{selectedUserGroup.UserGroupName}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div style="flex: 1; overflow-y: auto; overflow-x: hidden;" data-cy="task-user-selection-list-container">
        <div class="task-user-item"
             [ngClass]="{'task-user-item-selected': selectedUser === user, 'task-user-item-hovered': hoveredUser === user && hoveredUser !== selectedUser}"
             (click)="onItemClick(user)"
             (mouseover)="onItemMouseOver(user)"
             (mouseout)="onItemMouseOut(user)"
             *ngFor="let user of this.userList" data-cy="task-user-selection-item">
          {{user.UserName}}
        </div>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="task-user-selection-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="task-user-selection-cancel-button">Cancel</button>
      <button [disabled]="!selectedUser" (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="task-user-selection-ok-button">Ok</button>
    </div>
  </div>
</div>
